<template>
    <painel-component :itens="itensOne">
        <div class="filter-position" v-if="btnFilter">
            <button-one icon="filter" class="btn-filter" @click="filterWindow"/>
        </div>

        <form class="mb-4 mt-5">
            <transition name="fade-in-top">
                <row-component v-if="filter">
                    <row-col-component :class-row-col="'col-xxl-4 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'">
                        <label>Nome:</label>
                        <Multiselect :searchable="true" v-model="formDate.client_id" label="name"
                                     :options="selectClientList">
                            <template v-slot:singlelabel="{ value }">
                                <div class="multiselect-single-label">
                                    <img class="character-label-icon" :src="value.icon" alt=""> {{ value.name }}
                                </div>
                            </template>

                            <template v-slot:option="{ option }">
                                <img class="character-option-icon" :src="option.icon" alt=""> {{ option.name }}
                            </template>
                        </Multiselect>
                    </row-col-component>

                    <row-col-component :class-row-col="'col-xxl-4 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'">
                        <label>Status:</label>
                        <multiselect v-model="formDate.status" :searchable="true" :options="selectInput"
                                     :noResultsText="noResultsText" :noOptionsText="noResultsText"/>
                    </row-col-component>

                    <row-col-component
                            :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12 mt-0 mt-xxl-4'">
                        <button-one class="mx-1" @submit="submit" :icon="'search'"/>
                        <button-float class="mx-1" v-if="buttonCheck.create" :itens="itensTwo"/>
                    </row-col-component>
                </row-component>
            </transition>
        </form>

        <loder-send-component :text-title="'Carregando'" v-if="showLoader"/>

        <div v-else>
            <table class="table table-striped">
                <thead>
                <tr>
                    <th scope="col" style="width: 40%">Nome</th>
                    <th scope="col" style="width: 30%">Status</th>
                    <th scope="col" style="width: 10%" v-if="buttonCheck.show || buttonCheck.edit">Ações</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(profile, index) in customer_profile.data" :key="index">
                    <td data-label="Nome">
                        <img v-if="profile.photo" :src="profile.photo" alt="" class="avatar__image_2">
                        <img v-else src="@/assets/img/avatar.png" alt="" class="avatar__image_2">
                        {{ profile.name_client }}
                    </td>
                    <td data-label="Status">{{ statusString(profile.status) }}</td>
                    <td data-label="Ações" v-if="buttonCheck.show || buttonCheck.edit">
                        <button-show-round :route="'customer-profile-show'" :id-param="profile.id"
                                           v-if="buttonCheck.show"/>
                        <button-edit-round :route="'customer-profile-edit'" :id-param="profile.id"
                                           v-if="buttonCheck.edit"/>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <button-pagination :pagination="customer_profile" :offset="3" @paginate="loadCustomersProfiles"/>
    </painel-component>
</template>

<script>
import PainelComponent from "@/components/dashboard/PainelComponent";
import ButtonOne from "@/components/buttons/ButtonOne";
import ButtonFloat from "@/components/buttons/ButtonFloat";
import ButtonPagination from "@/components/buttons/ButtonPagination";
import RowComponent from "@/components/row/RowComponent";
import RowColComponent from "@/components/row/RowColComponent";
import ButtonShowRound from "@/components/buttons/ButtonShowRound";
import ButtonEditRound from "@/components/buttons/ButtonEditRound";
import LoderSendComponent from "@/components/LoderSendComponent";
import Multiselect from "@vueform/multiselect";
import {useToast} from "vue-toastification";

const toast = useToast();

export default {
    name: "CustomerProfileSearch",
    components: {
        PainelComponent,
        ButtonOne,
        ButtonFloat,
        ButtonPagination,
        RowComponent,
        RowColComponent,
        ButtonShowRound,
        ButtonEditRound,
        LoderSendComponent,
        Multiselect,
    },

    created() {
        this.$store.dispatch('updateNamePage', 'Perfil do Cliente')
        this.$store.dispatch('loadClientListSelect')
        this.loadCustomersProfiles(1)
        this.resizeWindow()
        this.checkACL()
    },

    data() {
        return {
            itensOne: {
                title: "Pesquisa",
                icon: "list alternate"
            },

            itensTwo: {
                route: "/customer-profile/create",
                icon: "plus",
                tooltip: '',
                name: ''
            },

            buttonCheck: {
                edit: false,
                create: false,
                show: false
            },

            formDate: {
                client_id: '',
                status: '',
            },

            filter: true,
            showLoader: true,
            btnFilter: false,
            searchSubmit: false,
        }
    },

    methods: {
        submit() {
            this.loadCustomersProfiles(1)
            this.searchSubmit = true;
        },

        loadCustomersProfiles(page) {
            this.showLoader = true
            if (!this.searchSubmit) {
                this.$store.dispatch('loadCustomersProfiles', {...this.params, page})
                    .then((r) => {
                        this.showLoader = false
                        if (this.searchSubmit) {
                            this.searchSubmit = false;
                            if (r.data.length === 0) {
                                toast.info("Nada foi encontrado com os parâmetros informados!", {timeout: 10000});
                            }
                        }
                    }).catch(() => {
                    this.showLoader = false
                    this.searchSubmit = false;
                });
            }
        },

        //profile-search
        //profile-create
        //profile-edit
        //profile-password -> liberar somente se tiver
        //profile-password-show -> liberar somente se tiver no show do search

        async checkACL() {
            this.$store.dispatch('ACLitens', 39)
                .then((r) => {
                    if (r.data.indexOf('profile-search') !== -1) {
                        this.showLoader = false
                        if (r.data.indexOf('profile-search') !== -1) {
                            this.buttonCheck.show = true
                        }

                        if (r.data.indexOf('profile-edit') !== -1) {
                            this.buttonCheck.edit = true
                        }

                        if (r.data.indexOf('profile-create') !== -1) {
                            this.buttonCheck.create = true
                        }
                    } else {
                        this.$router.push({name: 'home'})
                    }
                }).catch(() => {
                this.$router.push({name: 'home'})
            })
        },

        filterWindow() {
            this.filter = !this.filter
        },

        resizeWindow() {
            if (window.innerWidth <= 991) {
                this.filter = false
                this.btnFilter = true
            } else {
                this.filter = true
                this.btnFilter = false
            }
        },

        statusString(value) {
            if (parseInt(value) === 1)
                return 'Ativo'
            return 'Inativo'
        },
    },

    computed: {
        noResultsText() {
            return this.$store.state.var.selectNotSearch
        },

        selectClientList() {
            return this.$store.state.var.selectClientList;
        },

        selectInput() {
            return this.$store.state.var.selectActiveInactiveSearch;
        },

        customer_profile() {
            return this.$store.state.customer_profile.items
        },

        params() {
            return {
                page: this.customer_profile.current_page,
                client_id: this.formDate.client_id,
                status: this.formDate.status,
            }
        },
    },
}
</script>

<style scoped src="@/assets/css/table-resp.css"></style>
<style scoped>
.avatar__image_2 {
    border: 1px solid #d67c1c;
    height: 30px;
    width: 30px;
    object-fit: cover;
    border-radius: 50%;
    margin-right: 10px;
}
</style>